import type { MaybeRefOrGetter } from 'vue';

import { useOnboardedEffect } from './useOnboardedEffect';

interface UseOnboardedBootstrapOptions {
  dedupeKey?: MaybeRefOrGetter<string | null | undefined>;
}

export const useOnboardedBootstrap = (
  bootstrap: () => void | Promise<unknown>,
  options: UseOnboardedBootstrapOptions = {},
) => {
  useOnboardedEffect(bootstrap, options);
};
